<template>
  <a-flex vertical align="stretch" justify="space-between" gap="middle">
    <BaskitCollapsablePanel
      v-for="item in items"
      :key="item[keyField]"
      :header="item[headerField]"
      :item="item"
      :expanded="expandedPanelKey === item[keyField]"
      :isSelected="expandedPanelKey === item[keyField]"
      @toggle="panelToggled(item[keyField])"
    >
      <template v-if="!!$slots.headerData" #headerData>
        <slot name="headerData" :item="item" />
      </template>
      <template #panelData>
        <slot name="panelData" :item="item" />
      </template>
    </BaskitCollapsablePanel>
  </a-flex>
</template>

<script setup lang="ts">
import BaskitCollapsablePanel from "@/components/UI/BaskitCollapsablePanel.vue";

defineProps<{
  headerField: string;
  keyField: string;
  items: any[];
}>();

const expandedPanelKey = defineModel<any>("expandedPanelKey");

const panelToggled = (key: string) => {
  expandedPanelKey.value = key === expandedPanelKey.value ? null : key;
};
</script>

<style scoped lang="scss"></style>
